export default __webpack_public_path__ + "static/media/10-1.2b041b8a.mp3";